import React from 'react';
import PropTypes from 'prop-types';

const GlossaryTerms = ({ terms, t_controls }) => {
  const termsArray = Object.entries(terms);
  const columns = [];

  for (let i = 0; i < termsArray.length; i += 2) {
    columns.push(termsArray.slice(i, i + 2));
  }

  return (
    <div className="glossary-terms-container">
      <article className="heading-component">
        <div className="heading-component-inner">
          <h5 className="heading-component-title">
            {t_controls.title}
          </h5>
        </div>
      </article>
      <div className="game-glossary">
        <div className="game-glossary-wrap row-10">
          {columns.map((column, index) => (
            <div key={index} className="game-glossary-column">
              <table className="game-glossary-terms">
                <tbody>
                  {column.map(([key, value]) => (
                    <tr key={key}>
                      <td>{key}:</td>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

GlossaryTerms.propTypes = {
  terms: PropTypes.object.isRequired,
  t_controls: PropTypes.object.isRequired,
};

export default GlossaryTerms;